import { render } from "./DynaBadge.vue?vue&type=template&id=7f1c9050&scoped=true"
import script from "./DynaBadge.vue?vue&type=script&lang=js"
export * from "./DynaBadge.vue?vue&type=script&lang=js"

import "./DynaBadge.vue?vue&type=style&index=0&id=7f1c9050&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1c9050"]])

export default __exports__